import { useEffect, useState } from "react";

/**
 * Whole seconds elapsed since `startTs` (ISO timestamp), updating every second
 * while `active`. Returns 0 when inactive or when no start time is known.
 */
export function useElapsedSeconds(startTs: string | undefined, active: boolean): number {
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    if (!startTs || !active) {
      setElapsed(0);
      return;
    }
    const start = new Date(startTs).getTime();
    const tick = () => setElapsed(Math.max(0, Math.floor((Date.now() - start) / 1000)));
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [startTs, active]);

  return elapsed;
}
